import React from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import ACButton from '../../atoms/ACButton';
import { getInternalBaseUrl, getIndicatorColor } from '../../common/global.js';

import styles from './VirtualList.module.scss';

export default class VirtualList extends React.Component {
  onClickVirtual = (virtual) => {
    this.props.onSelectVirtualFunc(virtual);
  };

  onChangeSearchText = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { value = '' } = e.target;

    this.props.onChangeSearchTextFunc(value);
  };

  renderVirtuals() {
    const { virtuals } = this.props;
    if (isEmpty(virtuals)) return;

    return virtuals.map((virtual) => {
      return this.renderVirtual(virtual);
    });
  }

  renderVirtual(givenVirtual) {
    const { virtual = {} } = this.props;
    const { id = '', name = '', productId = '', status = '', note = {} } = givenVirtual;

    let gotToVirtualUrl = `${getInternalBaseUrl().virtuals}?id=${id}&productId=${productId}`;

    let s = [styles.virtualListItem];
    if (givenVirtual && givenVirtual.id === virtual.id) {
      s.push(styles.selected);
    }

    let privateNote = '';
    try {
      privateNote = note.private || '';
    } catch (error) {
      // console.error("Private note doesn't exist");
    }

    let borderLeftStyle = `3px solid ${getIndicatorColor(status)}`;

    return (
      <ListItem className={s.join(' ')} key={givenVirtual.id}>
        <div style={{ width: '100%', marginLeft: '5px', borderLeft: borderLeftStyle }}>
          <Link
            to={gotToVirtualUrl}
            style={{ textDecoration: 'none', color: 'inherit', width: '100%', padding: '10px' }}
            onClick={() => this.onClickVirtual(givenVirtual)}
          >
            <div className={styles.virtualName}>{name}</div>
            <div>{privateNote}</div>
          </Link>
        </div>
      </ListItem>
    );
  }

  render() {
    const { onCreateVirtualFunc } = this.props;
    return (
      <div className={styles.root}>
        <div className={styles.top}>
          <div className={styles.header}>
            Virtual Experience List
            <Link
              to={getInternalBaseUrl().virtuals + '?id='}
              style={{ textDecoration: 'none', color: 'inherit', padding: '10px' }}
            >
              <ACButton
                text={'Add'}
                icon={<AddCircleOutlineIcon key="iconAddVirtual" />}
                key="btnAddVirtual"
                onClickFunc={onCreateVirtualFunc}
              />
            </Link>
          </div>
          <TextField
            id="simple-start-adornment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            placeholder="Search"
            className={styles.search}
            value={this.props.searchText}
            onChange={this.onChangeSearchText}
          />
        </div>
        <div className={styles.bottom}>
          <List className={styles.virtualList}>{this.renderVirtuals()}</List>
        </div>
      </div>
    );
  }
}
